"use strict";
if (!Currency) {
    //return
}
//** Modifies the currency object returned by Shopify **/
function modifyConverter(Currency) {
    if (!Currency) {
        return;
    }
    Currency.cookie = {
        days: 365,
        name: "currency",
        write: function (value) {
            setCookie(this.name, value, this.days);
        },
        read: function () {
            return getCookie(this.name);
        },
    };
    Currency.moneyFormats = {
        USD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD" },
        EUR: {
            money_format: "€{{amount}}",
            money_with_currency_format: "€{{amount}} EUR",
        },
        GBP: {
            money_format: "£{{amount}}",
            money_with_currency_format: "£{{amount}} GBP",
        },
        CAD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD" },
        NZD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD" },
        AUD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD" },
    };
    Currency.formatMoney = function (b, g) {
        if (typeof Shopify.formatMoney === "function") return Shopify.formatMoney(b, g);
        if (typeof b === "string") {
            b = b.replace(".", "");
        }
        var f = "";
        var e = /\{\{\s*(\w+)\s*}}/;
        var a = g || "${{amount}}";
        function c(h, i) {
            return h === undefined ? i : h;
        }
        function d(m, k, l, j) {
            if (l === void 0) {
                l = undefined;
            }
            if (j === void 0) {
                j = undefined;
            }
            if (isNaN(m) || m === null) return 0;
            k = c(k, 2);
            l = c(l, ",");
            j = c(j, ".");
            var n = (m = (m / 100).toFixed(k)).split(".");
            var i;
            var h;
            return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, l) + (n[1] ? j + n[1] : "");
        }
        switch (a.match(e)[1]) {
            case "amount":
                f = d(b, 2);
                break;
            case "amount_no_decimals":
                f = d(b, 0);
                break;
            case "amount_with_comma_separator":
                f = d(b, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                f = d(b, 0, ".", ",");
        }
        return a.replace(e, f);
    };
    Currency.format = "money_with_currency_format";
    Currency.convertAll = function (c, b = "USD", a = "span.money", d = "money_with_currency_format") {
        c = c !== null && c !== void 0 ? c : "USD";
        var elements = dqa(a);
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (element.getAttribute("data-currency") !== b) {
                if (element.getAttribute("data-currency-" + b)) {
                    element.textContent = element.getAttribute("data-currency-" + b);
                } else {
                    var e = 0,
                        f = Currency.moneyFormats[c][d] || "{{amount}}",
                        g = Currency.moneyFormats[b][d] || "{{amount}}";
                    e =
                        -1 !== f.indexOf("amount_no_decimals")
                            ? Currency.convert(100 * parseInt(element.textContent.replace(/[^0-9]/g, ""), 10), c, b)
                            : "JOD" === c || "KWD" == c || "BHD" == c
                              ? Currency.convert(parseInt(element.textContent.replace(/[^0-9]/g, ""), 10) / 10, c, b)
                              : Currency.convert(parseInt(element.textContent.replace(/[^0-9]/g, ""), 10), c, b);
                    var h = Currency.formatMoney(e, g);
                    element.textContent = h;
                    element.setAttribute("data-currency-" + b, h);
                }
                element.setAttribute("data-currency", b);
            }
        }
        this.currentCurrency = b;
        this.cookie.write(b);
    };
    //var shopCurrency = "USD";
    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    //Currency.moneyFormats[shopCurrency].money_with_currency_format = '<span class="money">${{amount}} USD</span>';
    //Currency.moneyFormats[shopCurrency].money_format = '<span class="money">${{amount}}</span>';
    //Currency.moneyFormats[shopCurrency].money_without_trailing_zeros =
    //    '<span class="money">${{amount}} USD</span>';
}
function updateCurrency(Currency) {
    var _a;
    var shopCurrency = "USD";
    var cookieCurrency = Currency.cookie.read();
    if (cookieCurrency == "null") {
        cookieCurrency = shopCurrency;
    }
    var selectors = dqa("#currenciesOption option");
    for (var i_1 = 0; i_1 < selectors.length; i_1++) {
        var option = selectors[i_1];
        var flag = option.closest("data-currency");
        option.prepend("<span class='flag flag-us'></span>");
    }
    var currencyListSpans = dqa("#currencyList #listSpan");
    for (var i_2 = 0; i_2 < currencyListSpans.length; i_2++) {
        var listSpan = currencyListSpans[i_2];
        const countryFlag = "flag-" + ((_a = listSpan.closest("[data-currency]")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-currency"));
        listSpan.classList.add("flag", countryFlag);
    }
    if (cookieCurrency === shopCurrency) {
        for (var i = 0; i < selectors.length; i++) {
            selectors[i].classList.remove("selected");
        }
        var currencyListItems = dqa("#currencyList li");
        for (var i = 0; i < currencyListItems.length; i++) {
            currencyListItems[i].classList.remove("selected");
        }
        var flag = getById("currencyFlag");
        var currCurrency = getById("currentSpan");
        flag.removeAttribute("class");
        var selectedCurrency_1 = dq("#currencies span[data-currency='".concat(shopCurrency, "']"));
        selectedCurrency_1 === null || selectedCurrency_1 === void 0 ? void 0 : selectedCurrency_1.classList.add("selected");
        var selectedOption = dq("#currenciesOption option[data-currency='".concat(shopCurrency, "']"));
        selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.classList.add("selected");
        var selectedListItem = dq("#currencyList li[data-currency='".concat(shopCurrency, "']"));
        selectedListItem === null || selectedListItem === void 0 ? void 0 : selectedListItem.classList.add("selected");
        flag.classList.add("flag", "flag-".concat(shopCurrency));
        currCurrency.textContent = shopCurrency;
        Currency.currentCurrency = shopCurrency;
    } else {
        Currency.convertAll(shopCurrency, cookieCurrency);
        for (var i = 0; i < selectors.length; i++) {
            selectors[i].classList.remove("selected");
        }
        var currencyListItems = dqa("#currencyList li");
        for (var i = 0; i < currencyListItems.length; i++) {
            currencyListItems[i].classList.remove("selected");
        }
        var flag = getById("currencyFlag");
        var currCurrency = getById("currentSpan");
        var currCurrency = getById("currentSpan");
        currCurrency.removeAttribute("class");
        var selectedCurrency_2 = dq("#currencies span[data-currency='".concat(cookieCurrency, "']"));
        selectedCurrency_2 === null || selectedCurrency_2 === void 0 ? void 0 : selectedCurrency_2.classList.add("selected");
        var selectedOption = dq("#currenciesOption option[data-currency='".concat(cookieCurrency, "']"));
        selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.classList.add("selected");
        var selectedListItem = dq("#currencyList li[data-currency='".concat(cookieCurrency, "']"));
        selectedListItem === null || selectedListItem === void 0 ? void 0 : selectedListItem.classList.add("selected");
        flag.classList.add("flag", "flag-".concat(cookieCurrency));
        currCurrency.textContent = cookieCurrency;
        // currCurrency.nextElementSibling.textContent = cookieCurrency;
    }
    /** @type {HTMLDivElement}*/
    const currencySelector = getById("selectedCurrency");
    /** @type {HTMLUListElement}*/
    const currencyList = getById("currencyList");
    var currentSpan = getById("currentSpan");
    var flag = getById("currencyFlag");
    var currenciesSpan = dqa("#currencies span");
    var currencyListLi = dqa("#currencyList li");
    var selectedCurrencyClass = dqa(".selected-currency");
    var chevronSVG = dqa(".chevron svg");
    currencySelector?.addEventListener("click", function () {
        const isExpanded = currencySelector.getAttribute("aria-expanded") === "true";
        currencySelector.setAttribute("aria-expanded", isExpanded ? false : true);
        currencyList.classList.toggle("hideClist");
        currencyList.setAttribute("aria-hidden", isExpanded ? true : false);
        chevronSVG.forEach(function (element) {
            element.classList.toggle("rotateSVG");
        });
    });
    currencyListLi.forEach(function (li) {
        li.addEventListener("click", function (event) {
            flag.removeAttribute("class");
            currencyListLi.forEach(function (li) {
                li.removeAttribute("class");
            });
            var currTarget = event.currentTarget;
            currTarget.classList.add("selected");
            var newCurrency = currTarget.getAttribute("data-currency");
            Currency.convertAll(Currency.currentCurrency, newCurrency);
            cookieCurrency = newCurrency;
            //add flag and text
            flag.classList.add("flag", "flag-" + newCurrency);
            currentSpan.innerText = newCurrency;

            currencySelector.setAttribute("aria-expanded", false);
            currencyList.setAttribute("aria-hidden", true);
            currencyList.classList.toggle("hideClist");
        });
    });
    // For options.
    var originalSelectCallback = window.selectCallback;
    window.selectCallback = function (variant, selector) {
        originalSelectCallback(variant, selector);
        currenciesSpan.forEach(function (element) {
            if (element.classList.contains("selected")) {
                var selectedCurrency = element.getAttribute("data-currency");
                Currency.convertAll(shopCurrency, selectedCurrency);
                selectedCurrencyClass.forEach(function (element) {
                    element.innerText = Currency.currentCurrency;
                });
            }
        });
    };
    // For options.
    document.body.addEventListener("ajaxCart.afterCartLoad", function (cart) {
        currenciesSpan.forEach(function (element) {
            if (element.classList.contains("selected")) {
                var selectedCurrency = element.getAttribute("data-currency");
                Currency.convertAll(shopCurrency, selectedCurrency);
                selectedCurrencyClass.forEach(function (element) {
                    element.innerText = Currency.currentCurrency;
                });
            }
        });
    });
    selectedCurrencyClass.forEach(function (element) {
        element.innerText = Currency.currentCurrency;
    });
}
function init() {
    modifyConverter(Currency);
    updateCurrency(Currency);
}
window.addEventListener("load", init);
//$(document).ajaxComplete(curJquery);
